// import './registerServiceWorker'
// CSS
import '@/sass/main.scss'
import 'splitpanes/dist/splitpanes.css'
import '@jsplumb/browser-ui/css/jsplumbtoolkit.css'
import 'gridstack/dist/gridstack.min.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import 'rrweb/dist/rrweb.min.css'

import { Capacitor } from '@capacitor/core'
import VuePortal from '@linusborg/vue-simple-portal'
import { BrowserTracing } from "@sentry/tracing"
import * as Sentry from "@sentry/vue"
import { JeepSqlite } from 'jeep-sqlite/dist/components/jeep-sqlite'
// import 'gridstack/dist/h5/gridstack-dd-native'
import { PiniaVuePlugin } from 'pinia'
// import PortalVue from 'portal-vue'
import VMask from 'v-mask'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueVirtualScroller from 'vue-virtual-scroller'

import App from '@/App.vue'
// Plugins
import Dialog from '@/plugins/dialog'
import Notification from '@/plugins/notification'

import { useNotifications } from './store/notifications/use'
import { reportGitlabIssue } from './utils/gitlab'
// import router from './router'
// import vuetify from './plugins/vuetify'
// import { createI18n } from './plugins/i18n'
import { useGlobalVue } from './utils/use'

Vue.config.productionTip = true
Vue.config.performance = false
Vue.config.silent = false

Vue.use(VMask)
Vue.use(Dialog)
Vue.use(Notification)
Vue.use(VueI18n)
Vue.use(PiniaVuePlugin)
// Vue.use(PortalVue)
Vue.use(VuePortal)
Vue.use(VueVirtualScroller)

// TODO: [vue@>3.0.0] remove when migrating to vue 3
// Vue.config.warnHandler = (msg, instance, trace) => {
//   if (!msg.includes('Property or method "$id"')) {
//     console.warn(msg)
//     console.warn(trace)
//   }
// }

const { settings } = useGlobalVue()

// console.log('import.meta.env', import.meta.env)

if (import.meta.env.VITE_IS_MOBILE === '1') {
  customElements.define('jeep-sqlite', JeepSqlite)
  console.log(`after customElements.define`)

  const platform = Capacitor.getPlatform()

  if (platform === "web") {
  // Create the 'jeep-sqlite' Stencil component
    const jeepSqliteEl = document.createElement('jeep-sqlite')
    document.body.append(jeepSqliteEl)
    await customElements.whenDefined('jeep-sqlite')
    console.log(`after customElements.whenDefined`)
  }
}


if (import.meta.env.PROD) {
  Sentry.init({
    Vue,
    logErrors: true,

    // debug: true,
    dsn: "https://glet_726e5a92f20c72467d599df0471eef43@git.knitiv.net/api/v4/error_tracking/collector/5",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(settings.router),
      }),
    // new Sentry.Replay(),
    ],
    attachStacktrace: true,
    tracesSampleRate: 1,
    release: import.meta.env.TAG ?? 'dev',
    environment: import.meta.env.ENVIRONMENT ?? 'development',
  })
}

Vue.config.errorHandler = (msg, instance, trace) => {
  console.error(msg, instance, trace)
  const { error } = useNotifications()

  if (msg.message.includes('dyn') && msg.message.includes('imp')) {
    error('Une erreur est survenue lors du chargement de l\'application. Il est probable qu\'une nouvelle version soit disponible. Recharger la page pour corriger le probleme', {
      duration: 60_000,
      buttons: [
        {
          type: 'spacer',
        },
        {
          type: 'button',
          text: 'Recharger',
          handler: () => window.location.reload(),
        },
      ],
    })
  }
  else {
    error(msg.message, {
      title: 'Une erreur non gérée a été détecté',
      buttons: [
        {
          type: 'spacer',
        },
        {
          type: 'button',
          text: 'Ouvrir Gitlab',
          handler: () => {
            reportGitlabIssue(`${msg.name} ${msg.message}`, msg.stack ?? 'No stack')
          },
        },
      ],
    })

  }
  Sentry.captureException(msg)
}

console.time('App mounted')
new Vue({
  i18n: settings.i18n,
  router: settings.router,
  pinia: settings.pinia,
  vuetify: settings.vuetify,
  render: (h: any) => h(App),
}).$mount('#app')
